import axios from 'axios';
// import do utilitário, nunca do contexto
import { fnCleanStorage } from '../utils/authStorage';

const getAuthorizationAccessToken = () =>
  localStorage.getItem('cAccessToken') || null;

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}api/`,
});

api.interceptors.request.use(
  (req) => {
    const token = getAuthorizationAccessToken();
    if (token) req.headers.Authorization = `Bearer ${token}`;
    return req;
  },
  (err) => Promise.reject(err)
);

api.interceptors.response.use(
  (res) => {
    const qrUrl = localStorage.getItem('qrCodeUrl');
    if (qrUrl) {
      window.location.href = qrUrl;
      localStorage.removeItem('qrCodeUrl');
    }
    return res;
  },
  (err) => {
    if (err?.request?.status === 401) {
      fnCleanStorage();
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
